import { render, staticRenderFns } from "./table-notas.vue?vue&type=template&id=5cae23d2&scoped=true&"
import script from "./table-notas.vue?vue&type=script&lang=js&"
export * from "./table-notas.vue?vue&type=script&lang=js&"
import style0 from "./table-notas.vue?vue&type=style&index=0&id=5cae23d2&prod&scoped=true&lang=css&"
import style1 from "./table-notas.vue?vue&type=style&index=1&id=5cae23d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cae23d2",
  null
  
)

export default component.exports